import { useEffect } from 'react';
import type { Transition } from '@/hooks/useDashboard';

const TOAST_TTL_MS = 9000;

/**
 * Transition toasts.
 *
 * Fired only on genuine status changes, never on a routine refresh — a wall
 * display that flashes every 30s trains people to stop looking at it.
 */
export function Toasts({
  transitions,
  onExpire,
}: {
  transitions: Transition[];
  onExpire: () => void;
}) {
  useEffect(() => {
    if (!transitions.length) return;
    const timer = setTimeout(onExpire, TOAST_TTL_MS);
    return () => clearTimeout(timer);
  }, [transitions, onExpire]);

  if (!transitions.length) return null;

  return (
    <div className="toasts" aria-live="polite">
      {transitions.slice(-4).map((t) => (
        <div className={`toast is-${t.to}`} key={t.key}>
          <div className="toast__title">
            {t.serviceName} is {t.to}
          </div>
          <div className="toast__body">
            was {t.from} · {new Date(t.at).toLocaleTimeString()}
          </div>
        </div>
      ))}
    </div>
  );
}
